<section class="tt-ai-chat-conversation-list" aria-label="Conversations">
    <div class="tt-ai-chat-conversation-list__heading">
        <strong ttTranslateWord="tt_heading_chats"></strong>
    </div>
    <p *ngIf="loading" class="tt-ai-chat-conversation-list__status" ttTranslateWord="loading_conversations"></p>
    <p *ngIf="!loading && chats.length === 0" class="tt-ai-chat-conversation-list__status" ttTranslateWord="no_conversations_yet"></p>
    <tt-toast *ngIf="actionError" role="alert" ttType="danger" [ttMessage]="actionError" [ttTranslateMessage]="false"></tt-toast>

    <ng-container *ngIf="providerNamesByKeyno$ | async as providerNamesByKeyno">
        <tt-context-menu-container *ngFor="let chat of chats; trackBy: trackChat" [ttContext]="chat" [ttDisabled]="!!busyChatKeyno || loading">
            <button *ngIf="renamingChat?.ai_chat_keyno !== chat.ai_chat_keyno; else renameEditor"
                type="button" class="tt-ai-chat-conversation-list__button"
                [attr.data-chat-keyno]="chat.ai_chat_keyno"
                [class.tt-ai-chat-conversation-list__button--selected]="chat.ai_chat_keyno === selectedChat?.ai_chat_keyno"
                (click)="chatSelected.emit(chat)">
                <span>{{ chat.ai_chat_name }}</span>
                <small>
                    <ng-container *ngIf="providerNamesByKeyno[chat.ai_provider_keyno] as providerName">{{ providerName }} &middot; </ng-container>
                    {{ chat.mod_datetime | formatDate: "datetime" : false }}
                </small>
            </button>
            <ng-template #renameEditor>
                <div class="tt-ai-chat-conversation-list__button">
                    <label class="sr-only" [attr.for]="renameInputId" ttTranslateWord="chat_name"></label>
                    <input #renameInput [id]="renameInputId" class="tt-ai-chat-conversation-list__rename-input"
                        type="text" maxlength="300" [(ngModel)]="renameName" [disabled]="!!busyChatKeyno"
                        (keydown.enter)="$event.preventDefault(); saveRename()" (keydown.escape)="cancelRename($event)">
                    <div class="tt-ai-chat-conversation-list__rename-actions">
                        <button type="button" ttTranslateWord="save" [disabled]="!!busyChatKeyno || !renameName.trim()"
                            (click)="saveRename()"></button>
                        <button type="button" ttTranslateWord="cancel" [disabled]="!!busyChatKeyno" (click)="cancelRename()"></button>
                    </div>
                </div>
            </ng-template>
            <tt-context-menu>
                <tt-context-menu-item ttText="archive_chat" ttIcon="far fa-archive" (ttClick)="requestArchive($event)" />
                <tt-context-menu-item ttText="rename_chat" ttIcon="far fa-edit" (ttClick)="beginRename($event)" />
            </tt-context-menu>
        </tt-context-menu-container>
    </ng-container>
</section>
